import { CircularProgress } from "@mui/material";
import React from "react";
import theme from "../../theme/schema.json";

const ButtonLoader = (props) => {
  return (
    <CircularProgress
      size={props.loaderSize || 50}
      sx={{ color: props.color ? props.color : "var(--primary-foreground)" }}
    />
  );
};

export default ButtonLoader;
